"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWhatsApp = void 0;

var React = __importStar(require("react"));

exports.IconWhatsApp = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.37 21.18C23.06 22.05 21.57 22.84 20.85 22.95C20.2 23.05 19.39 23.09 18.5 22.8C17.7765 22.5783 17.0655 22.318 16.37 22.02C12.63 20.41 10.18 16.66 9.99 16.41C9.8 16.16 8.47 14.4 8.47 12.57C8.47 10.74 9.44 9.84002 9.78 9.47002C10.12 9.10002 10.53 9.01002 10.78 9.01002C11.03 9.01002 11.28 9.01002 11.49 9.02002C11.72 9.03002 12.03 8.93002 12.33 9.66002C12.64 10.41 13.39 12.23 13.48 12.42C13.57 12.6 13.64 12.82 13.51 13.07C13.39 13.32 13.32 13.47 13.14 13.69C12.95 13.91 12.75 14.17 12.58 14.34C12.39 14.53 12.2 14.73 12.42 15.1C12.64 15.47 13.39 16.69 14.5 17.68C15.93 18.94 17.13 19.34 17.5 19.52C17.87 19.71 18.09 19.68 18.31 19.43C18.53 19.18 19.24 18.34 19.49 17.97C19.74 17.6 19.99 17.66 20.33 17.78C20.67 17.9 22.51 18.8 22.88 18.99C23.25 19.18 23.5 19.27 23.6 19.42C23.69 19.58 23.69 20.32 23.38 21.19L23.37 21.18ZM26.64 5.37002C25.2527 3.98221 23.6045 2.88252 21.7905 2.13425C19.9764 1.38597 18.0323 1.0039 16.07 1.01002C7.84 1.01002 1.13 7.68002 1.13 15.88C1.12595 18.4889 1.81254 21.0524 3.12 23.31L1 31.01L8.92 28.94C11.1123 30.1282 13.5664 30.7503 16.06 30.75H16.07C24.3 30.75 31 24.08 31.01 15.88C31.0159 13.9243 30.6326 11.9869 29.8823 10.1808C29.1321 8.37469 28.0299 6.73593 26.64 5.36002",
    fill: color
  }));
});